import styled from 'styled-components';
import { BLACK } from "@styles/colors"
import { INTER } from "@styles/fonts"
import { safeAreaInset } from "@lib/telegram";

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 32px 12px 100px 12px;
  gap: 16px;
  overflow-y: auto;
`;

export const SelectedAccountContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 14px 12px;
  border: 1px solid #E0E0E0;
  border-radius: 12px;
`;

export const DetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 8px;
`;

export const AlertContainer = styled.div`
  margin-top: -8px;
`;

export const FixedButtonContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 16px 12px 24px 12px;
  padding-bottom: ${safeAreaInset().bottom || 24}px;
  background-color: white;
  box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.1);
`;

export const DetailsBox = styled.div`
  border: 1px solid #E0E0E0;
  border-radius: 12px;
  padding: 14px 12px;
  gap: 8px;
  display: flex;
  flex-direction: column;
`;

export const ProviderInformationBoxText = styled.div`
  color: ${BLACK};
  font-family: ${INTER.medium};
  font-size: 12px;
`